<template>
  <div class="opportunity-lookup-result-field-ui">
    <span class="opportunity-lookup-result-field-ui__label">{{ label }}</span>
    <span class="opportunity-lookup-result-field-ui__value"
      >{{ formattedValue }} <CopyBtn v-if="hasCopyBtn && value" @click="copy"
    /></span>
  </div>
</template>

<script lang="ts" setup>
  // Services
  import { ClipboardService } from '~/misc/services/clipboard';

  // Components
  import CopyBtn from '~/misc/btn/copy/CopyBtn.vue';

  const props = defineProps({
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, null] as PropType<string | number | null>,
      default: '',
    },
    hasCopyBtn: {
      type: Boolean,
      default: false,
    },
  });

  const { success } = useToast();

  const formattedValue: ComputedRef<string | number> = computed<string | number>(
    () => props.value || '-'
  );

  const copy = () => {
    if (!props.value) return;

    ClipboardService.copy(String(props.value));
    success({ message: `${props.value} copied to clipboard` });
  };
</script>
